import {
    createSlice
} from "@reduxjs/toolkit";
import {
    getDashboard
} from "./thunk";
export const initialState = {
    data:[],
    adminVerificationStatus: null,
    error: "", // for error message
    loading: false,
};


const dashboardSlice = createSlice({
    name: "dashboard",
    initialState,
    // reducers: {
    //     apiError(state, action) {
    //         state.error = action.payload.data;
    //         state.loading = true;
    //         state.isUserLogout = false;
    //         state.errorMsg = true;
    //     },
    //     updateBusinessInfo(state, action) {
    //         if (action.payload.business_type) {
    //             state.works.business_type = action.payload.business_type
    //         }
    //         if (action.payload.gst_in) {
    //             state.works.gst_in = action.payload.gst_in
    //         }
    //         //   state.businessInfo = action.payload
    //         state.loading = false;
    //         state.errorMsg = false;
    //     },

    // },
    extraReducers: (builder) => {
        builder
            .addCase(getDashboard.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
           .addCase(getDashboard.fulfilled, (state, action) => {
            // Check if profile_verified_admin is directly inside action.payload
            state.data = action.payload; 
            console.log('verification status' , action.payload?.profile_verified_admin)
            state.adminVerificationStatus = action.payload?.profile_verified_admin; // Adjusting based on the correct structure
            state.loading = false;
})
            .addCase(getDashboard.rejected, (state, action) => {
                state.error = action.payload?.error || null;
                state.loading = false;
            });
    }
});

// export const {
//     updateBusinessInfo
// } = businessInfoSlice.actions

export default dashboardSlice.reducer;